<div id="header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <p>Swipesum Chat Session</p>
  <div style="padding-right: 5px">
    <mat-icon (click)="close()">close</mat-icon>
  </div>
</div>

<div id="body">
  @if (userInfo.isEmpty()) {
    <div id="questionnaire" class="shared">
      <p>
        Welcome to Swipesum Chat! Before we get started, please confirm the
        following information:
      </p>
      <div>
        <div>Your name</div>
        <input type="text" [(ngModel)]="this.userInfo.name" />
      </div>
      <div>
        <div>Email</div>
        <input type="text" [(ngModel)]="this.userInfo.email" />
      </div>
      <div>
        <div>Callback number</div>
        <input type="text" [(ngModel)]="this.userInfo.phone" />
      </div>
      <div>
        <input type="button" value="Start chat" (click)="activate()" />
      </div>
    </div>
  }

  <!-- TODO (jacob): When does this run? -->
  @if (!this.chatActive && this.conversationId) {
    <div id="join-session-notification" class="shared">
      <div>Conversation {{ this.conversationId }}<br /></div>
      <div>You about to join a chat session with [name].</div>
      <div>
        <input type="button" value="Join Session" (click)="join()" />
      </div>
    </div>
  }

  @if (this.chatActive) {
    <div id="active-chat">
      <div id="chat-window"><div #chatWindow></div></div>
      <textarea
        id="message-box"
        (keyup.enter)="send()"
        #chatMessageBox
        rows="3"
        style="overflow: hidden; resize: none"
        placeholder="Type your message here..."
      ></textarea>
      <div>
        @if (!conversationId) {
          <input
            id="close"
            type="button"
            class="button_secondary button_var_3"
            value="Close"
            (click)="close()"
          />
        }
        @if (conversationId) {
          <input
            id="end"
            type="button"
            class="button_secondary button_var_3"
            value="End"
            (click)="end()"
          />
        }
        @if (conversationId) {
          <input
            id="send"
            type="button"
            class="button_primary button_var_3"
            value="Send"
            (click)="send()"
          />
        }
      </div>
    </div>
  }
</div>
